import { render, staticRenderFns } from "./LiveLayout.vue?vue&type=template&id=93741470"
import script from "./LiveLayout.vue?vue&type=script&lang=js"
export * from "./LiveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93741470')) {
      api.createRecord('93741470', component.options)
    } else {
      api.reload('93741470', component.options)
    }
    module.hot.accept("./LiveLayout.vue?vue&type=template&id=93741470", function () {
      api.rerender('93741470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/layouts/LiveLayout.vue"
export default component.exports